(function () {

  let isTaggedBlogPage;
  // let featuredArticleSections;

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initBlogPage);
  } else {
    initBlogPage();
  }

  function initBlogPage() {
    isTaggedBlogPage = window.location.pathname.includes('/tagged/');

    // featuredArticleSections = document.getElementsByClassName('plug-featured-articles');

    if (isTaggedBlogPage) {
      loadSidebarLatestArticles();
    } else {
      const mainArticleSection = document.getElementsByClassName('plug-main-article')[0];
      if (mainArticleSection) {
        // const articleBody = document.getElementsByClassName('plug-article__body')[0];
        // const rteElements = articleBody.children;
        // const linkedTextData = {
        //   autophagy: {
        //     numChanged: 0,
        //     href: '/pages/what-is-autophagy',
        //     regex: /autophagy|Autophagy/g
        //   },
        //   spermidine: {
        //     numChanged: 0,
        //     href: '/pages/what-is-spermidine',
        //     regex: /spermidine|Spermidine/g
        //   }
        // };
        //
        // function buildLink() {
        //
        // }
        //
        // let k = 0;
        // while (k < rteElements.length) {
        //   const elementK = rteElements[k];
        //   const tag = elementK.tagName.toLowerCase();
        //   if (
        //     !elementK.classList.contains('article-template__social-sharing')
        //     && !elementK.classList.contains('plug-article__tags')
        //   ) {
        //     let autophagyMatches;
        //     let spermidineMatches;
        //     if (tag === 'p') {
        //       autophagyMatches = elementK.textContent.match(/autophagy|Autophagy/g);
        //       spermidineMatches = elementK.textContent.match(/autophagy|Autophagy/g);
        //       console.log({matches});
        //     } else if (tag.charAt(0) === 'h') {
        //       matches = elementK.textContent.match(/autophagy|Autophagy/g);
        //       console.log({matches});
        //
        //     } else if (tag === 'ol' || tag === 'ul') {
        //
        //     }
        //   }
        //   k += 1;
        // }
      }
    }

    // let k = 0;
    // while (k < featuredArticleSections.length) {
    //   setupArticleList(featuredArticleSections[k]);
    //   k += 1;
    // }
  }

  function loadSidebarLatestArticles() {
    const mainSection = document.getElementsByClassName('plug-main-blog')[0];
    const pathname = location.pathname.split('/tagged')[0];

    getFreshSection('plug-main-blog', (newSection, err) => {
      if (err) throw err;
      console.log({newSection});

      replaceElement(
        mainSection.querySelector('.plug-blog-sidebar__latest-articles-container'),
        newSection.querySelector('.plug-blog-sidebar__latest-articles-container')
      );
    }, pathname);
  }

// Utility functions

  function replaceElement(oldEle, newEle) {
    const parent = oldEle.parentElement;
    parent.insertBefore(newEle, oldEle);
    parent.removeChild(oldEle);
  }

  function getFreshSection(
    sectionId,
    cb,
    path=location.pathname,
    queryString=location.search
  ) {
    fetch(
      queryString !== ''
        ? path + queryString + '&section_id=' + sectionId
        : path + '?section_id=' + sectionId
    )
      .then(response => response.text())
      .then(newSectionText => {
        console.log(newSectionText);
        const domparser = new DOMParser();
        const parsedDoc = domparser.parseFromString(newSectionText, 'text/html');
        const newSection = parsedDoc.body.children[0];
        return cb(newSection);
      })
      .catch(error => {
        return cb(undefined, error);
      });
  }
  //
  // function setupArticleList(section) {
  //   let slider;
  //   let sliderPreviousButton;
  //   let sliderNextButton;
  //   let seeMoreButton;
  //   let resizeTimer;
  //   let listWrapper;
  //   let list;
  //
  //   list = section.getElementsByClassName('plug-articles-slider__list')[0];
  //   listWrapper = section.getElementsByClassName('plug-articles-slider__list-wrapper')[0];
  //   if (!isMobile()) {
  //     buildSlider();
  //   }
  //   initSeeMoreButton();
  //   initSliderButtons();
  //
  //   window.addEventListener('resize', () => {
  //     clearTimeout(resizeTimer);
  //     resizeTimer = setTimeout(() => {
  //       let mobile = isMobile();
  //       if (!mobile && !slider) {
  //         buildSlider();
  //       } else if (mobile && slider) {
  //         destroySlider();
  //       }
  //     }, 200);
  //   });
  //
  //   function buildSlider() {
  //     slider = new Flickity(list, {
  //       cellAlign: 'left',
  //       wrapAround: false,
  //       contain: true,
  //       pageDots: false,
  //       prevNextButtons: false
  //     });
  //
  //     slider.on('change', (index) => {
  //       sliderPreviousButton.disabled = (index === 0);
  //       sliderNextButton.disabled = (index >= slider.cells.length - 3);
  //     });
  //   }
  //
  //   function destroySlider() {
  //     if (slider) {
  //       slider.destroy();
  //       slider = undefined;
  //     }
  //   }
  //
  //   function initSeeMoreButton() {
  //     seeMoreButton =  section.getElementsByClassName('plug-articles-slider__see-more-btn')[0];
  //     seeMoreButton.addEventListener('click', () => {
  //       listWrapper.classList.toggle('is-expanded');
  //     });
  //   }
  //
  //   function initSliderButtons() {
  //     sliderPreviousButton.addEventListener('click', () => {
  //       slider.previous(false, false);
  //       sliderNextButton.disabled = false;
  //     });
  //     sliderNextButton.addEventListener('click', () => {
  //       slider.next(false, false);
  //       sliderPreviousButton.disabled = false;
  //     });
  //   }
  // }
  //
  // function isMobile() {
  //   return window.innerWidth < 990;
  // }

})();
